import { render } from "./crime_statistics.vue?vue&type=template&id=734d5382"
import script from "./crime_statistics.vue?vue&type=script&lang=js"
export * from "./crime_statistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__